/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 medal2.glb --transform 
Files: medal2.glb [3.26MB] > H:\objects\medal2-transformed.glb [342.29KB] (90%)
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Medal2(props) {
  const { nodes, materials } = useGLTF('3dmodels/medal2-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={[1, 0.038, 1]}>
        <mesh geometry={nodes.Cylinder_1.geometry} material={materials.Awers} />
        <mesh geometry={nodes.Cylinder_2.geometry} material={materials['Awers.001']} />
        <mesh geometry={nodes.Cylinder_3.geometry} material={materials.Bok} />
      </group>
    </group>
  )
}

useGLTF.preload('3dmodels/medal2-transformed.glb')
